import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity9 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_9;
}

export default CobbledRoadTileEntity9;
